import React from 'react';
import {
  TextField,
  InputAdornment,
  Button as MuiButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { AgGridReact } from 'ag-grid-react';
import { Dialog } from '../../../../../../Components/MUIs';
import ConfirmDialog from '../../../../../../Components/ConfirmDialog';
import GridFunctions from '../../../../../../Services/agGrid/ag-Grid-functions';

/**
 * 기존 위험성평가 불러오기 모달
 * RIS_BASIC_01/modals/RiskAssessmentListModal.js와 동일 UI/동작
 */
const RiskAssessmentListModal = ({
  open,
  onClose,
  onSelect,
  onDoubleClick,
  rowData = [],
  columnDefs = [],
  gridRef,
  searchText = '',
  setSearchText,
}) => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [pendingRow, setPendingRow] = React.useState(null);

  const HandleSearch = () => {
    if (gridRef?.current) {
      gridRef.current.api.setQuickFilter(searchText);
    }
  };

  const HandleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      HandleSearch();
    }
  };

  const HandleSelectionChanged = () => {
    GridFunctions.onSelectionChanged(gridRef, (selected) => {
      setSelectedRows(selected);
    });
  };

  const HandleSave = () => {
    if (selectedRows.length > 0) {
      setPendingRow(selectedRows[0]);
      setConfirmOpen(true);
    }
  };

  const HandleConfirm = () => {
    const selected = pendingRow || selectedRows[0];
    if (selected) {
      onSelect?.(selected);
      setConfirmOpen(false);
      setPendingRow(null);
      onClose?.();
    }
  };

  const HandleRowDoubleClick = (e) => {
    setPendingRow(e?.data || null);
    setConfirmOpen(true);
  };

  return (
    <div
      role="presentation"
      className="MuiDialog-root MuiModal-root"
      inert="true"
    >
      <Dialog
        title={
          <>
            위험성평가 목록
            <TextField
              placeholder="검색"
              variant="outlined"
              size="small"
              sx={{
                mx: 2,
                '& .MuiOutlinedInput-root': {
                  paddingRight: 0,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ height: '100%' }}>
                    <MuiButton
                      edge="end"
                      size="small"
                      sx={{
                        borderLeft: 1,
                        borderColor: 'divider',
                        color: 'rgba(0, 0, 0, 0.54)',
                      }}
                      style={{
                        padding: '0px',
                        borderRadius: '0px',
                        borderTopRightRadius: '8px',
                        borderBottomRightRadius: '8px',
                      }}
                      onClick={HandleSearch}
                    >
                      <SearchIcon sx={{ m: 0 }} style={{ margin: '0px' }} />
                    </MuiButton>
                  </InputAdornment>
                ),
              }}
              onKeyDown={HandleSearchKeyDown}
              value={searchText}
              onChange={(e) => setSearchText?.(e.target.value)}
            />
          </>
        }
        open={open}
        onClose={onClose}
        contentSx={{ display: 'flex', flexDirection: 'column' }}
        fullWidth
        maxWidth="md"
        saveButtonName="선택"
        closeButtonName="닫기"
        useSaveButton={true}
        useSaveAfterClose={false}
        onSave={HandleSave}
        content={
          <div
            className="ag-theme-alpine no-scroll"
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact
              ref={gridRef}
              animationRows={true}
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={{
                minWidth: 100,
                editable: false,
                resizable: true,
                sortable: true,
                filter: true,
                floatingFilter: true,
              }}
              rowSelection="single"
              onSelectionChanged={HandleSelectionChanged}
              getRowStyle={(e) => GridFunctions.getRowStyle(e)}
              onRowDoubleClicked={HandleRowDoubleClick}
            />
          </div>
        }
      />
      <ConfirmDialog
        open={confirmOpen}
        title="확인"
        contentText="현재 작성 중인 내용을 덮어쓰고 새로 불러오시겠습니까?"
        onSave={HandleConfirm}
        onClose={() => {
          setConfirmOpen(false);
          setPendingRow(null);
        }}
        saveButtonName="확인"
        closeButtonName="취소"
      />
    </div>
  );
};

export default RiskAssessmentListModal;

